module.exports = __webpack_public_path__ + "static/media/img_british_heart.55239cba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_british_heart.png
// module id = 107
// module chunks = 0